import { render } from "./IconCart.vue?vue&type=template&id=bb90df30&scoped=true"
import script from "./IconCart.vue?vue&type=script&lang=js"
export * from "./IconCart.vue?vue&type=script&lang=js"

import "./IconCart.vue?vue&type=style&index=0&id=bb90df30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb90df30"]])

export default __exports__